/**
 * 药品代理商系统路由配置
 * 增量开发，不影响原有系统
 */

const agentRoutes = {
  path: '/agent',
  name: 'AgentSystem',
  redirect: '/agent/daily-office',
  meta: { 
    title: '药品代理商系统',
    icon: 'shop',
    system: 'agent'
  },
  children: [
    // ========== 1. 日常办公 ==========
    {
      path: 'daily-office',
      name: 'AgentDailyOffice',
      redirect: '/agent/daily-office/memo',
      meta: { title: '日常办公', icon: 'calendar' },
      children: [
        {
          path: 'approval',
          name: 'AgentApproval',
          component: () => import('@/views/agent/daily-office/approval/index.vue'),
          meta: { title: '审批流程' }
        },
        {
          path: 'memo',
          name: 'AgentMemo',
          component: () => import('@/views/agent/daily-office/memo/index.vue'),
          meta: { title: '备忘录' }
        },
        {
          path: 'notification',
          name: 'AgentNotification',
          component: () => import('@/views/agent/daily-office/notification/index.vue'),
          meta: { title: '消息提醒' }
        }
      ]
    },

    // ========== 2. 基础数据（核心模块） ==========
    {
      path: 'basic-data',
      name: 'AgentBasicData',
      redirect: '/agent/basic-data/terminal',
      meta: { title: '基础数据', icon: 'database' },
      children: [
        {
          path: 'terminal',
          name: 'AgentTerminal',
          component: () => import('@/views/agent/basic-data/terminal/index.vue'),
          meta: { title: '终端数据库' }
        },
        {
          path: 'customer',
          name: 'AgentCustomer',
          component: () => import('@/views/agent/basic-data/customer/index.vue'),
          meta: { title: '客户管理' }
        },
        {
          path: 'hospital-filing',
          name: 'AgentHospitalFiling',
          component: () => import('@/views/agent/hospital-filing/index.vue'),
          meta: { title: '医院备案' }
        },
        {
          path: 'product',
          name: 'AgentProduct',
          component: () => import('@/views/agent/basic-data/product/index.vue'),
          meta: { title: '产品管理' }
        },
        {
          path: 'salesman',
          name: 'AgentSalesman',
          component: () => import('@/views/agent/basic-data/salesman/index.vue'),
          meta: { title: '业务员管理' }
        },
        {
          path: 'master-data-center',
          name: 'AgentMasterDataCenter',
          component: () => import('@/views/agent/basic-data/master-data-center/index.vue'),
          meta: { title: '主数据管理中心' }
        }
      ]
    },

    // ========== 3. 业务管理 ==========
    {
      path: 'business',
      name: 'AgentBusiness',
      redirect: '/agent/business/bidding',
      meta: { title: '业务管理', icon: 'shop' },
      children: [
        {
          path: 'bidding',
          name: 'AgentBidding',
          component: () => import('@/views/agent/bidding/index.vue'),
          meta: { title: '竞标管理' }
        },
        {
          path: 'sales',
          name: 'AgentSales',
          component: () => import('@/views/agent/sales/index.vue'),
          meta: { title: '销售管理' }
        },
        {
          path: 'assessment',
          name: 'AgentAssessment',
          component: () => import('@/views/agent/assessment/index.vue'),
          meta: { title: '考核管理' }
        }
      ]
    },

    // ========== 4. 财务管理 ==========
    {
      path: 'finance',
      name: 'AgentFinance',
      redirect: '/agent/finance/fee-setting',
      meta: { title: '财务管理', icon: 'dollar' },
      children: [
        {
          path: 'fee-setting',
          name: 'AgentFeeSetting',
          component: () => import('@/views/agent/fee-setting/index.vue'),
          meta: { title: '费用设置' }
        },
        {
          path: 'payment',
          name: 'AgentPayment',
          component: () => import('@/views/agent/payment/index.vue'),
          meta: { title: '货款管理' }
        },
        {
          path: 'settlement',
          name: 'AgentSettlement',
          component: () => import('@/views/agent/settlement/index.vue'),
          meta: { title: '空间结算' }
        }
      ]
    },

    // ========== 5. 报表管理 ==========
    {
      path: 'reports',
      name: 'AgentReports',
      component: () => import('@/views/agent/reports/index.vue'),
      meta: { title: '报表管理', icon: 'bar-chart' }
    },

    // ========== 6. 数据分析 ==========
    {
      path: 'analysis',
      name: 'AgentAnalysis',
      component: () => import('@/views/agent/analysis/index.vue'),
      meta: { title: '数据分析', icon: 'line-chart' }
    },

    // ========== 7. 系统管理 ==========
    {
      path: 'system',
      name: 'AgentSystemManagement',
      component: () => import('@/views/agent/system/index.vue'),
      meta: { title: '系统管理', icon: 'setting' }
    }
  ]
}

export default agentRoutes